<template>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <component :is="tag" :id="$attrs.id" v-html="html" />
</template>

<script>
export default {
    props: {
        html: { type: String, required: true },
        tag: { type: String, default: 'span' },
    },
}
</script>
